import {Component} from '@angular/core';
import {FileUploadComponent} from "../../../../shared/commons/app-file-upload/file-upload/file-upload.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {Page} from "../../../../../generated-model/model";

@Component({
  selector: 'app-uc-advance-register',
  standalone: true,
  imports: [
    FileUploadComponent,
    FormsModule,
    NgbPagination,
    NotFoundComponent,
    ReactiveFormsModule
  ],
  templateUrl: './uc-advance-register.component.html',
  styleUrl: './uc-advance-register.component.scss'
})
export class UcAdvanceRegisterComponent {
  pageData: Page<any> = {number: 0, size: 10};

  search($event: number = 1) {

  }

}
